// Components==============
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { encodeURL } from 'utilities/encodeURL';
import { useMediaQ } from 'utilities/useMediaQ';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import Modal from './components/Modal';
import Video from './components/Video';
import './index.module.scss';
// =========================

const ConditionalLink = ({ link, children }) => {
    if (link?.includes('http')) {
        return (
            <a href={link} target="_blank" rel="noreferrer">
                {children}
            </a>
        );
    }

    if (link) {
        return <NavLink to={`/${link}`}>{children}</NavLink>;
    }

    return children;
};

export default function Card({
    row,
    column,
    width,
    title,
    description,
    image,
    popupImage,
    popupContent,
    page,
    video,
    videoType,
    link,
    backgroundOverlay,
    textBackground,
    background,
    personImage,
    homepage,
}) {
    const openModal = useOpenUrlModal(`card-popup/${encodeURL(title)}`);

    const desktop = useMediaQ('min', 765);
    const phone = useMediaQ('max', 500);

    function handleClick() {
        if (video) return;
        if (popupContent.length) return openModal();
    }

    const gridStyle = desktop
        ? {
              gridRow: row || 'initial',
              gridColumn: column ? `${column} / ${column + width}` : 'initial',
              height: 270,
          }
        : phone
        ? {
              height: 'auto',
          }
        : {
              height: 270,
          };
    return (
        <>
            {/* <HoverableCard style={gridStyle}> */}
            <motion.div
                onClick={handleClick}
                whileHover={{ scale: 1.025 }}
                whileTap={{ scale: 0.975 }}
                styleName={`wrapper ${
                    textBackground ? 'background-color' : ''
                } ${personImage !== 'none' ? 'person-image' : ''}`}
                style={{
                    ...gridStyle,
                    backgroundImage: `url(${image})`,
                    backgroundColor: !image && background,
                    padding: video ? 0 : '',
                }}
            >
                {video ? (
                    <Video
                        homepage={homepage}
                        video={video}
                        videoType={videoType}
                    />
                ) : (
                    <ConditionalLink link={link} page={page}>
                        {image && (
                            <div
                                style={{
                                    background: `${backgroundOverlay}`,
                                }}
                                styleName="overlay"
                            />
                        )}
                        <div
                            style={
                                textBackground
                                    ? { background: `${textBackground}` }
                                    : {}
                            }
                            styleName={`flex `}
                        >
                            <div>
                                <h3>{title}</h3>
                                <p>{description}</p>
                            </div>
                            {personImage !== 'none' && (
                                <div styleName={`right person-${personImage}`}>
                                    <div styleName="person-wrapper">
                                        <img
                                            src={`/images/persons/person${personImage}.png`}
                                            alt={title}
                                        />
                                    </div>
                                </div>
                            )}
                            {/* <Button
                                background={buttonBackground}
                                color={buttonColor}
                                style={{ width: "max-content" }}
                            >
                                {buttonText}
                            </Button> */}
                        </div>
                    </ConditionalLink>
                )}
            </motion.div>
            <AnimatePresence>
                <Modal
                    title={title}
                    description={description}
                    image={popupImage}
                    richText={popupContent}
                />
            </AnimatePresence>
            {/* </HoverableCard> */}
        </>
    );
}
